export default __webpack_public_path__ + "static/media/bot-factory.a8af6a27.svg";